<template>
  <div>
    <RadioGroup ref="g1" v-if="type == 1" v-model="defaultAnswer[1]" @on-change="handleChange"  style="width:100%;">
      <div v-for="(item , index) in values" class="item">
        <Radio :key="item.key" :label="item.value" >
          <span>{{item.label}}</span>
        </Radio>
        <a type="primary" @click="handleRemove(item)">移除</a>
      </div>
    </RadioGroup>
    <CheckboxGroup ref="g2" v-if="type == 2" v-model="defaultAnswer[2]" @on-change="handleChange" style="width:100%;">
      <div v-for="(item , index) in values" class="item">
        <Checkbox :key="item.key" :label="item.value" >
          <span>{{item.label}}</span>
        </Checkbox>
        <a type="primary" @click="handleRemove(item)">移除</a>
      </div>
    </CheckboxGroup>
    <RadioGroup ref="g3" v-if="type == 0" v-model="defaultAnswer[0]" @on-change="handleChange">
      <Radio v-for="(item) in defaultNP" :key="item.value" :label="item.value" >
        <span>{{item.label}}</span>
      </Radio>
    </RadioGroup>
    <div v-if="type == 1 || type == 2">
      <Button type="primary" shape="circle" icon="ios-add" @click="handleAdd()">添加</Button>
    </div>
  </div>
  
</template>
<script>
export default {
  data() {
    return {
      display: false,
      values:[],
      insVal:null,
      currentOption:null,
      inputOption:null,
      defaultAnswer:[
        null , null ,[] 
      ],
      defaultNP:[{value:'A',label:'正确'},{value:'B',label:'错误'}]
    }
  },
  props: {
    // 0、判断题，1、单选，2、多选
    type: {
      type: Number,
      default: 1
    },

    data:{
      default:function(){
        return []
      }
    },

    answer:{
      type:[Number , String , Array]
    }
  },
  watch:{
    data(val){
      if(val){
        this.setData( val )
      }
    },

    value(val , ov){
      if(ov !== val){
        // select value = null 时 会转为 undefined 并触发一次 on-change
        this.insVal = val === null ? undefined : val
      }
    },

    type(nv){
      if(nv === undefined || nv === null){
        console.log('reset')
        this.reset()
      }else{
        this.setAnswer()
        this.update()
      }
    },
    answer(nv , ov){
      this.setAnswer()
    }
  },

  computed:{

  },
  created(){
    if( this.data && this.data.length ){
      this.values = this.data
    }
  },
  methods: {
    setData(){
      if( this.type == 1 || this.type == 2){
        this.values = this.data.map( i => {
          return {
            raw:i.content
          }
        })
        this.render()
      }
    },
    setAnswer(data){
      if(this.answer !== undefined && typeof(this.answer) == 'string'){
        if( this.type == 0){
          this.defaultAnswer[0] = this.answer
        }
        else if( this.type == 1){
          this.defaultAnswer[1] = this.answer
        }
        else if(this.type == 2){
          this.defaultAnswer[2] = this.answer ? this.answer.split(',') : []
        }
      }
    },
    reset(){
      this.values = []
      this.defaultAnswer = [null , null , []]
    },

    dispatch(componentName, eventName, params) {
      let parent = this.$parent || this.$root;
      let name = parent.$options.name;
      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;
        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit(...[eventName].concat(params));
      }
    },


    getAnswers(){
      let defaultAnswer = [].concat( this.defaultAnswer[this.type] ).sort()
      return {
        options : this.type == 0 ? [{'seq':'A',content:'正确'},{'seq':'B',content:'错误'}] : this.values.map(i=>({
          seq : i.value,
          content : i.raw
        })),
        defaultAnswer: defaultAnswer.join(',')
      }
    },
    handleChange(val){

      if( this.type !== null){
        //this.defaultAnswer[this.type] = val
      }
      this.update()

    },

    update(){
      let modelValue = this.getAnswers()

      this.$emit('on-change',modelValue)

      if(!this.silent){
        this.dispatch('FormItem', 'on-form-change',  [].concat(modelValue))
      }
    },

    create(val){
      this.values.push({raw:this.inputOption})
      this.render()
      this.update()
    },
    handleRemove(item){
      this.values.splice(item.index , 1)
      this.removeAnswerByValue(item.value)
      //如果被选中移除对应答案
      this.render()
      this.update()
    },
    removeAnswerByValue(value){
      if( this.type == 1 ){
        if( this.defaultAnswer[this.type] == value ){
          this.defaultAnswer[this.type] = ''
        }
      }
      else if(this.type == 2){
        const index = this.defaultAnswer[this.type].findIndex( i => i == value)
        if( index >= 0){
          this.defaultAnswer[this.type].splice( index , 1)
        }
      }

    },
    render(){
      this.values.forEach((i , index)=>{
        i.value = ('ABCDEFGHIJKLMN')[index]
        i.label = `${i.value}、${i.raw}`
        i.index = index
      })
    },

    handleAdd () {
      this.$Modal.confirm({
        render: (h) => {
          return h('Input', {
            data:{
              value:''
            },
            props: {
              autofocus: true,
              placeholder: '请输入答案'
            },
            on: {
              input: (val) => {
                this.inputOption = val
              }
            }
          })
        },
        onOk:()=>{
          this.create()
        }
      })
    }
  }
}

</script>
<style lang="scss" scoped>
.item{
  width:100%;
  display:flex;
  justify-content: space-between;
  padding:0 10px;
  &>*{
    flex:1 1 auto;
  }
  &:hover{
    background:rgba(0,0,0,.06);
  }

  a{
    flex:0 0 35px;
    font-size:12px;
  }

}
</style>